import Vue from 'vue';
import store from '@/store';
import logger from './logger';

Vue.config.errorHandler = (err, vm, info, a) => {
    store.commit('errorLog/addErrorLog', {
        err,
        vm,
        info,
        url: window.location.href
    });
    logger.error(err, info);
};
